import React from 'react';
import { FadeIn } from './FadeIn';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="py-16 px-4 bg-padel-surface" data-id="element-65">
      <div className="max-w-3xl mx-auto text-center" data-id="element-66">
        <FadeIn data-id="element-67">
          <ShieldCheckIcon className="w-16 h-16 text-padel-lime mx-auto mb-6" data-id="element-68" />
          <h2 className="text-3xl font-display font-bold text-white mb-6" data-id="element-69">
            La garantía es simple porque el producto es serio.
          </h2>
          <p className="text-lg text-gray-300 leading-relaxed mb-6" data-id="element-70">
            Abrís los tomos. Los usás en la pista. Si en 7 días no es
            exactamente lo que esperabas, te devolvemos el 100% del dinero. Sin
            formularios. Sin preguntas. Sin drama.
          </p>
          <div className="inline-block bg-padel-dark border border-padel-muted px-6 py-3 rounded-lg" data-id="element-71">
            <p className="text-padel-lime font-bold" data-id="element-72">
              La tasa de devolución es menor al 1%.
            </p>
            <p className="text-sm text-gray-400 mt-1" data-id="element-73">
              No porque tengamos una política de devolución difícil. Sino porque
              el sistema funciona.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}